"use strict";
/**
 * Created on 11 20 2019
 */

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ObjectUtils_1 = require("../../core/utils/ObjectUtils"); //tslint:disable:max-classes-per-file

/**
 * Helper structure to store reference to product and sellout type.
 * <br/>
 * Structure can be used as key of immutable map.
 *
 * @author JMe
 */


var ProductSelloutType =
/*#__PURE__*/
function () {
  /**
   * @param productId internal id of internal product
   * @param selloutType type of sellout
   */
  function ProductSelloutType(productId, selloutType) {
    _classCallCheck(this, ProductSelloutType);

    this.productId = productId;
    this.selloutType = selloutType;
  }

  _createClass(ProductSelloutType, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof ProductSelloutType) {
        return other.productId === this.productId && other.selloutType === this.selloutType;
      }

      return false;
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode("".concat(this.productId, "-").concat(this.selloutType));
    }
  }]);

  return ProductSelloutType;
}();

exports.ProductSelloutType = ProductSelloutType;
/**
 * Extends {@link ProductSelloutType} about reference to {@link InternalSite}.
 * <br/>
 * Structure can be used as key of immutable map.
 *
 * @author JMe
 */

var ProductSiteSelloutType =
/*#__PURE__*/
function (_ProductSelloutType) {
  _inherits(ProductSiteSelloutType, _ProductSelloutType);

  /**
   * @param productId internal id of internal product
   * @param siteId internal id of internal site
   * @param selloutType type of sellout
   */
  function ProductSiteSelloutType(productId, siteId, selloutType) {
    var _this;

    _classCallCheck(this, ProductSiteSelloutType);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductSiteSelloutType).call(this, productId, selloutType));
    _this.productId = productId;
    _this.siteId = siteId;
    _this.selloutType = selloutType;
    return _this;
  }

  _createClass(ProductSiteSelloutType, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof ProductSiteSelloutType) {
        return other.productId === this.productId && other.siteId === this.siteId && other.selloutType === this.selloutType;
      }

      return false;
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode("".concat(this.productId, "-").concat(this.siteId, "-").concat(this.selloutType));
    }
  }]);

  return ProductSiteSelloutType;
}(ProductSelloutType);

exports.ProductSiteSelloutType = ProductSiteSelloutType;